import React from "react";
import { Pagination } from "react-bootstrap";

const CustomedPagination = (props) => {
  const { totalPage, currentPage, onPaginationLinkClick } = props;

  let formatedCurrentPage = 1;
  if (typeof currentPage == "string") {
    formatedCurrentPage = parseInt(currentPage);
  } else {
    formatedCurrentPage = currentPage;
  }

  const breakPoint = 10;
  const minSpaceForEllipsis = 3;
  const test = breakPoint + minSpaceForEllipsis;

  const paginateItems = [];

  if (totalPage <= breakPoint) {
    for (let i = 1; i <= totalPage; i++) {
      paginateItems.push(
        <Pagination.Item
          key={`page-${i}`}
          onClick={() => {
            onPaginationLinkClick(i);
          }}
          active={i == formatedCurrentPage}
        >
          {i}
        </Pagination.Item>
      );
    }
  } else if (formatedCurrentPage <= breakPoint && totalPage >= test) {
    for (let i = 1; i <= breakPoint + 1; i++) {
      paginateItems.push(
        <Pagination.Item
          key={`page-${i}`}
          onClick={() => {
            onPaginationLinkClick(i);
          }}
          active={i == formatedCurrentPage}
        >
          {i}
        </Pagination.Item>
      );
    }

    paginateItems.push(<Pagination.Ellipsis key={`ellipsises`} />);
    paginateItems.push(
      <Pagination.Item
        key={`page-${totalPage}`}
        onClick={() => {
          onPaginationLinkClick(totalPage);
        }}
      >
        {totalPage}
      </Pagination.Item>
    );
  } else if (formatedCurrentPage >= totalPage - minSpaceForEllipsis) {
    paginateItems.push(
      <Pagination.Item
        key={`page-1`}
        onClick={() => {
          onPaginationLinkClick(1);
        }}
      >
        1
      </Pagination.Item>
    );
    paginateItems.push(<Pagination.Ellipsis key={`ellipsises`} />);

    for (
      let i = formatedCurrentPage - minSpaceForEllipsis;
      i <= totalPage;
      i++
    ) {
      paginateItems.push(
        <Pagination.Item
          key={`page-${i}`}
          onClick={() => {
            onPaginationLinkClick(i);
          }}
          active={i == formatedCurrentPage}
        >
          {i}
        </Pagination.Item>
      );
    }
  } else if (formatedCurrentPage > breakPoint && totalPage > test) {
    paginateItems.push(
      <Pagination.Item
        key={`page-1`}
        onClick={() => {
          onPaginationLinkClick(1);
        }}
      >
        1
      </Pagination.Item>
    );
    paginateItems.push(<Pagination.Ellipsis key={`ellipsis`} />);

    for (let i = formatedCurrentPage - 1; i <= formatedCurrentPage + 1; i++) {
      paginateItems.push(
        <Pagination.Item
          key={`page-${i}`}
          onClick={() => {
            onPaginationLinkClick(i);
          }}
          active={i == formatedCurrentPage}
        >
          {i}
        </Pagination.Item>
      );
    }

    paginateItems.push(<Pagination.Ellipsis key={`ellipsis-2`} />);
    paginateItems.push(
      <Pagination.Item
        key={`page-${totalPage}`}
        onClick={() => {
          onPaginationLinkClick(totalPage);
        }}
      >
        {totalPage}
      </Pagination.Item>
    );
  }

  return (
    <Pagination className="justify-content-center pb-5 gap-2 rounded">
      {paginateItems}
    </Pagination>
  );
};

export default CustomedPagination;
